import './apiloader.css'

const ApiLoader = () => {
    return (
        <div className="flex absolute righ-0 bottom-0 w-full h-screen items-center justify-center bg-[#0000] backdrop-blur-md">
            <div className="loader"></div>
        </div>

    );
};

export default ApiLoader;
